<template>
  <el-menu
    class="menu-vertical"
    background-color="#0271B3"
    text-color="#fff"
    active-text-color="#fff"
    :collapse-transition="false"
    :collapse="isCollapse"
    :default-active="activeIndex"
    popper-class="poperClass"
    @open="handleOpen"
    @close="handleClose"
    ref="elMenu"
  >
    <!-- default-active="0" :default-openeds="['0']"-->
    <!-- <menu-loop :menuItemList="menuList" :menuAllList="menuList" ref="menuloopItem"></menu-loop> -->
    <!-- :is="menuItem.children!=undefined&&menuItem.children!=null&&menuItem.children.length>0?'el-submenu':'el-menu-item'"  -->
    <template v-for="menuItem in menuList">
      <el-submenu
        v-if="
          menuItem.children !== undefined &&
            menuItem.children !== null &&
            menuItem.children.length > 0 &&
            menuItem.isOnlyOneLevel !== true
        "
        :key="menuItem.name"
        :index="menuItem.path"
      >
        <template slot="title">
          <i :class="menuItem.meta.icon" />
          <span>{{ $t(menuItem.meta.title) }}</span>
        </template>
        <template v-for="menuChildItem in menuItem.children">
          <el-submenu
            v-if="
              menuChildItem.children !== undefined &&
                menuChildItem.children !== null &&
                menuChildItem.children.length > 0 &&
                menuItem.isOnlyOneLevel != true
            "
            :key="menuChildItem.name"
            :index="menuChildItem.path"
          >
            <template slot="title">
              <i :class="menuChildItem.meta.icon" />
              <span>{{ $t(menuChildItem.meta.title) }}</span>
            </template>
            <template v-for="menuChildItem2 in menuChildItem.children">
              <el-menu-item
                v-if="
                  menuChildItem2.meta.routeNameParent === undefined ||
                    menuChildItem2.meta.routeNameParent === null ||
                    menuChildItem2.meta.routeNameParent === ''
                "
                :key="menuChildItem2.name"
                :index="menuChildItem2.path"
                @click="openPage(menuChildItem2)"
              >
                <i :class="menuChildItem2.meta.icon" style="visibility: hidden;" />
                <span slot="title">{{ $t(menuChildItem2.meta.title) }}</span>
              </el-menu-item>
            </template>
          </el-submenu>

          <template v-else>
            <el-menu-item
              v-if="
                menuChildItem.meta.routeNameParent === undefined ||
                  menuChildItem.meta.routeNameParent === null ||
                  menuChildItem.meta.routeNameParent === ''
              "
              :key="menuChildItem.name"
              :index="menuChildItem.path"
              @click="openPage(menuChildItem)"
            >
              <i :class="menuChildItem.meta.icon" style="visibility: hidden;" />
              <span slot="title">{{ $t(menuChildItem.meta.title) }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-submenu>
      <el-menu-item
        v-else-if="
          menuItem.meta.routeNameParent === undefined ||
            menuItem.meta.routeNameParent === null ||
            menuItem.meta.routeNameParent === ''
        "
        :key="menuItem.name"
        :index="menuItem.path"
        @click="openPage(menuItem)"
      >
        <i :class="menuItem.meta.icon" />
        <span slot="title">{{ $t(menuItem.meta.title) }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import store from '@/store/index.js'
// import router from "@/router";
// import menuLoop from "./menuLoop";
import { roleSelectUserRole } from '@/api/adminManagement.js'

const menuListTemp = [] // 菜单列表临时变量

export default {
  components: {
    // "menu-loop": menuLoop
  },
  props: { isCollapse: Boolean, activeIndex: String },
  // template:"#templateMenuList",
  data() {
    return {
      oldActiveIndex: "",//this.activeIndex,//原来的激活项
      menuList: menuListTemp,
      isClickMenuItem: false // 是否点击菜单项
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (menuListTemp === null || menuListTemp.length === 0) {
      this.menuList = store.getters.MenuList
    }

    this.oldActiveIndex = this.$refs.elMenu.activeIndex
    if(!this.oldActiveIndex){
      // this.oldActiveIndex = this.$route.path
      //如果没获取到活动序号，可能是非导航菜单中的序号，则在加载完成后再获取一次（加载完成后会根据子页面选中父页面的序号）
      this.$nextTick(function(){
        this.oldActiveIndex = this.$refs.elMenu.activeIndex
      })
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath)
    },
    handSelect(key, keyPath) {
      // key: 选中菜单项的 index, keyPath: 选中菜单项的 index path
      // console.log(key, keyPath)
    },
    openPage(menuItem) {
      if (
        menuItem === undefined ||
        menuItem === null ||
        menuItem.path === null ||
        menuItem.path === ''
      ) {
        return
      }

      roleSelectUserRole()
      .then(result => {
        if (result.code === 404) {
          // token失效
          const navCom = this.$refs.elMenu
          if(this.oldActiveIndex){
            navCom.updateActiveIndex(this.oldActiveIndex) // 更新激活项
          }
          const curItem = navCom.items[menuItem.path] // 现在选中的项
          if(curItem){
            curItem.$el.blur()
          }
          
          return
        } else {
          const routeCur = { path: menuItem.path }
          this.$router.push(routeCur)
          this.isClickMenuItem = true
          this.oldActiveIndex = menuItem.path
        }
      })

      // const routeCur = { path: menuItem.path }
      // this.$router.push(routeCur)
      // this.isClickMenuItem = true
    },
    InitData() {}
  }
}

// 判断路由是否存在
export function IsExistRoute(routeItemCur, routeItemArray, parentRouteItem) {
  let isExist = false
  parentRouteItem =
    parentRouteItem !== undefined && parentRouteItem !== null
      ? parentRouteItem
      : {
        path: ''
      }
  for (let i = 0; i < routeItemArray.length; i++) {
    const routeItem = routeItemArray[i]
    const routePath =
      (parentRouteItem.path !== '' ? parentRouteItem.path + '/' : '') +
      routeItem.path

    if (
      routeItemCur.path == routePath ||
      (routeItemCur.name !== undefined &&
        routeItemCur.name !== null &&
        routeItemCur.name == routeItem.name)
    ) {
      isExist = true
      break
    }

    const routeItemChildren = routeItem.children
    if (
      routeItemChildren !== undefined &&
      routeItemChildren !== null &&
      routeItemChildren.length > 0
    ) {
      isExist = IsExistRoute(routeItemCur, routeItemChildren, routeItem)
      if (isExist) {
        break
      }
    }
  }

  return isExist
}

// 菜单排序
function menuDataSort(a, b) {
  const maxSeq = 999999999
  if (a.seq === undefined || a.seq === null || a.seq === '' || isNaN(a.seq)) {
    a.seq = maxSeq
  }
  if (b.seq === undefined || b.seq === null || b.seq === '' || isNaN(b.seq)) {
    b.seq = maxSeq
  }
  if (a.children !== undefined && a.children !== null && a.children.length > 1) {
    a.children.sort(menuDataSort)
  }
  if (b.children !== undefined && b.children !== null && b.children.length > 1) {
    b.children.sort(menuDataSort)
  }

  return a.seq - b.seq
}
</script>
<style scoped>
.menu-vertical {
  min-height: 100%;
  border-right: solid 1px #0271b3;
}

.menu-vertical:not(.el-menu--collapse) {
  width: 250px;
}

.el-menu-item{
  padding-left: 50px !important;
}

 .el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.21) !important;
  border-left: solid 5px #18c7ee;
  padding-left: 45px !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.21) !important;
  border-left: solid 5px #18c7ee;
  padding-left: 45px !important;
}

.el-menu .el-submenu__title i {
  color: white;
  font-size: 16px;
}

.el-menu-item i {
  color: white;
}
</style>
